var sw = window.innerWidth;
var sh = window.innerHeight;
var header = document.querySelector("header");
var sticky = 0;


// Font Resizer-------------------Start
function fontResizer() {
    var perc = parseInt(sw) / 120;
    document.body.style.fontSize = perc + 'px';
}

let headerss = document.querySelector("header");

if (headerss) {
    function setNavigation() {
        let current_location = location.pathname.split("/")[1];
        if (current_location === "") return;
        let menu_items = document.querySelector("header").getElementsByTagName("a");
        for (let i = 0, len = menu_items.length; i < len; i++) {
            if (menu_items[i].getAttribute("href").indexOf(current_location) !== -1) {
                menu_items[i].classList.add("active");
            }
        }
    }
    setNavigation();
}


// Loader-------------------Start
function pageLoader() {
    // document.querySelector("html").classList.add("loadjs");
    setTimeout(function () {
        document.querySelector(".loader-first").style.display = 'none';
        document.querySelector("html").classList.remove("loadjs");
    }, 300);
}


// Navigation slide Active on a mobile 
let toggleMenu = document.querySelector('#toggle');
let htmlEl = document.querySelector("html");

toggleMenu.addEventListener("click", (event) => {
    console.log('this', event)
    let _this = event.target;
    _this.classList.toggle('active');
    document.querySelector('.navigation').classList.toggle('open')
    htmlEl.classList.toggle("overflow-hidden");
})

// Landscape Mode off 
function landscapeModeOff() {
    if (sh < 450 && sw > 480 && sw < 820) {
        document.getElementById("portrait-warnning").style.display = "flex";
    } else {
        document.getElementById("portrait-warnning").style.display = "none";
    }
}


// Sticky Header----------------Start
function stickyHeader() {
    if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
    } else {
        header.classList.remove("sticky");
    }
}


// SVG Convert Code
let svgs = document.querySelectorAll('img.svg-convert');
svgs.forEach((el) => {
    const imgID = el.getAttribute('id');
    const imgClass = el.getAttribute('class');
    const imgURL = el.getAttribute('src');

    fetch(imgURL)
        .then((response) => response.text())
        .then(data => {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(data, 'text/html');
            let svg = xmlDoc.querySelector('svg');
            if (typeof imgID !== 'undefined') {
                svg.setAttribute('id', imgID);
            }

            if (typeof imgClass !== 'undefined') {
                svg.setAttribute('class', imgClass + ' svg-converted');
            }

            svg.removeAttribute('xmlns:a');

            el.parentNode.replaceChild(svg, el);
        })
});

// Window on Load-----------------Start
window.onload = function () {
    pageLoader();
    if (sw > 1199) {
        fontResizer();
    }
};

// Window On Resize-----------------Start
window.addEventListener('resize', (event) => {
    sw = window.innerWidth;
    sh = window.innerHeight;
    landscapeModeOff();
    if (sw > 1025) {
        if (sw < 1400 && sw > 1300 && sh > 900) {} else {
            fontResizer();
        }
    }
});


// Window On Scroll-----------------Start
window.addEventListener('scroll', (event) => {
    stickyHeader();
});

if (document.querySelector(".heroSlider")) {
    var heroSlider = new Swiper(".heroSlider", {
        slidesPerView: 1,
        allowTouchMove: true,
        spaceBetween: 20,
        breakpoints: {
            700: {
                slidesPerView: 1.8,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 2.3,
                spaceBetween: 20,
            },
        },
    });
}
if (document.querySelector(".our-clients__client-slider")) {
    var clientSlider = new Swiper(".our-clients__client-slider", {
        slidesPerView: 1,
        allowTouchMove: true,
        spaceBetween: 20,
        loop: true,
        speed: 2000,
        autoplay: {
            enable: true,
            delay: 2500,
            disableOnInteraction: false,
        },
        breakpoints: {
            700: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 5,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 8,
                spaceBetween: 55,
            },
        },
    });
}

// Footer Mob Dropdown-----END
let allAccord = document.body.querySelectorAll(".js-accord");
if (allAccord.length > 0) {
    for (let i = 0; i < allAccord.length; i++) {
        const setActive = (el) => {
            let bol = el.classList.contains("opened");
            [...el.parentElement.parentElement.children].forEach((sib) => {
                sib.children[0].classList.remove("opened");
                let panel = sib.children[1];
                panel.style.maxHeight = null
            });
            if (bol == !1) {
                el.classList.add("opened");
                let panel = el.nextElementSibling;
                panel.style.maxHeight = panel.scrollHeight + "px"
            }
        };
        let spans = [...allAccord[i].querySelectorAll(".js-acccontent > h5")];
        spans.forEach((el) => el.addEventListener("click", (e) => setActive(el)))
    }
}

if (allAccord && allAccord.length) {
    let mainacc = document.querySelectorAll(".js-acccontent > h5");
    mainacc[0].classList.add("opened");
    mainacc[0].nextElementSibling.style.maxHeight =
        mainacc[0].nextElementSibling.scrollHeight + "px";
}

var acc = document.getElementsByClassName("toggle-btn");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].querySelector("p").addEventListener("click", function () {
        this.classList.toggle("opened");

        /* Toggle between hiding and showing the active panel */
        var panel = this.nextElementSibling;
        console.log("checking height", panel.style.maxHeight);
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
}

if (sw < 1200) {
    let mobileToggle = document.querySelectorAll(".mobileToggle");

    for (let i = 0; i < mobileToggle.length; i++) {
        mobileToggle[i].addEventListener("click", (event) => {
            mobileToggle[i].classList.toggle("open--menu");
            mobileToggle[i].nextElementSibling.classList.toggle("openMegaMenu");
        });
    }
}

if (sw < 1200) {
    let mobileToggle2nd = document.querySelectorAll(".sub-mobileToggle");

    for (let i = 0; i < mobileToggle2nd.length; i++) {

        mobileToggle2nd[i].addEventListener("click", (event) => {
            mobileToggle2nd[i].classList.toggle("open--menu2nd");
            mobileToggle2nd[i].nextElementSibling.classList.toggle("openMegaMenu2nd");
        });
    }
}

// document.querySelector('.search-btn').addEventListener('click', function (event) {
//     event.preventDefault();
//     var target = document.querySelector('header');
//     if (target.classList.contains('search-open')) {
//         target.classList.remove('search-open');
//     } else {
//         target.classList.add('search-open');
//     }
// });

var progress = document.querySelector('.company-overview__documents');
var isInViewport = function (elem) {
    var bounding = elem.getBoundingClientRect();
    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};
window.addEventListener('scroll', function (event) {
    if (isInViewport(progress)) {

        const counters = document.querySelectorAll(".bottom-wrapper:not(.counter-complete) .counter");

        if (counters) {
            counters.forEach((counter) => {
                counter.innerText = "0";

                const updateCounter = () => {
                    const target = +counter.getAttribute("data-target");
                    const c = +counter.innerText;

                    const increment = target / 1000;
                    console.log(increment);

                    if (c < target) {
                        counter.innerText = `${Math.ceil(c + increment)}`;
                        setTimeout(updateCounter, 1);
                    } else {
                        counter.innerText = target;
                    }
                    const factual_results = document.querySelectorAll(".bottom-wrapper");
                    factual_results[0].classList.add('counter-complete')
                };

                updateCounter();
            });
        }
    }
});





if (document.querySelector(".home-hero__heroSlider")) {
    var heroSlider = new Swiper(".home-hero__heroSlider", {
        slidesPerView: 1,
        allowTouchMove: true,
        loop: false,
        on: {
            init: function (e) {
                const slide = e.slides[0];
                addIFrame(e.slides, 0);
                // if (sw < 767) {
                //     addIFrameMobile(e.slides, 0);
                // }
            },
            slideChange: function ({
                realIndex,
                slides
            }) {
                addIFrame(slides, realIndex);
                // if (sw < 767) {
                //     addIFrameMobile(slides, realIndex);
                // }
            }
        }
    });
}

function addIFrame(slide, index) {
    slide.forEach(item => {
        let x = item.children[0].getElementsByClassName('iframeVidz');
        if (x.length) {
            x[0].remove()
        }
    })
    let dsrc1 = document.querySelector(".iframeData").getAttribute("data-src");
    let iFrame1 =
        '<iframe class="iframeVidz" src="' +
        dsrc1 +
        '" style=""></iframe>';
    setTimeout(function () {
        let a = slide[index].querySelector(".iframeData")
        if (a) {
            a.innerHTML = iFrame1
        }
    }, 500);
}

// function addIFrameMobile(slide, index) {
//     slide.forEach(item => {
//         let x = item.children[0].getElementsByClassName('iframeVidz');
//         if (x.length) {
//             x[0].remove()
//         }
//     })
//     let dsrc1 = document.querySelector(".iframeDataMobile").getAttribute("data-src");
//     let iFrame1 =
//         '<iframe class="iframeVidz" src="' +
//         dsrc1 +
//         '" style=""></iframe>';
//     setTimeout(function () {
//         let a = slide[index].querySelector(".iframeDataMobile")
//         if (a) {
//             a.innerHTML = iFrame1
//         }
//     }, 500);
// }


let avail = document.querySelectorAll(".modal");

function Modal(modalMainWrapper, backdrop, show) {

    let modal = document.querySelector(modalMainWrapper),
        modal_backdrop = document.querySelector(backdrop),
        show_modals = document.querySelectorAll(show);

    show_modals.forEach(function (show_modal) {
        show_modal.addEventListener("click", function (e) {
            e.stopPropagation();
            modal.classList.add("show");
            modal_backdrop.classList.add("show");
        });
    })



    document.addEventListener("click", function (e) {
        e.stopPropagation();
        if (e.target.closest(".modal")) {
            // console.log("modal")
            if (e.target.matches(".modal__cancel")) {
                // console.log(e.target.matches(".modal__cancel")  )
                modal.classList.remove("show");
                modal_backdrop.classList.remove("show");
            }
        } else {
            modal.classList.remove("show");
            modal_backdrop.classList.remove("show");
        }
    });

}

if (avail) {
    Modal(".modal", ".modal-backdrop", ".show-modal");
}